<script setup>
const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    isFirst: {
        type: Boolean,
        required: false,
        default: false
    },
    isLast: {
        type: Boolean,
        required: false,
        default: false
    },
    isExpandable: {
        type: Boolean,
        required: false,
        default: true
    },
    isExpanded: {
        type: Boolean,
        required: false,
        default: false
    },
    hasActiveChild: {
        type: Boolean,
        default: false,
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
})
</script>
<template>
    <li v-if="Object.keys(item).length > 0">
        <div
            class="px-3 py-1 transition-colors group"
            :class="[
                isFirst ? '' : '',
                isExpanded ? '-bg-gray-50' : '',
                hasActiveChild ? '-border-l-3 -border-l-brandPrimary-500' : '',
            ]"
        >
            <div
                class="flex items-center pr-2 border border-transparent rounded-md hover:bg-gray-50 hover:border-gray-100"
                :class="[
                    hasActiveChild ? '-border-l-3 -border-l-brandPrimary-500' : '',
                ]"
            >
                <div class="flex items-center justify-center w-8 h-8 flex-shrink-0">
                    <logo-icon
                        v-if="item.useLogoIcon"
                        class="w-5 h-5 text-brandPrimary-500"
                    />
                    <i
                        v-else
                        :class="['fa-light', item.icon, 'text-lg text-gray-400 group-hover:text-gray-600']"
                    ></i>
                </div>
                <template v-if="showLabel">
                    <span class="ml-1 text-sm font-medium text-gray-700 group-hover:text-gray-900 truncate flex-1 tracking-tight">
                        {{ _mft(item.name) }}
                    </span>
                    <span v-if="isExpandable" class="ml-auto">
                        <i
                            class="fa-light text-xs text-gray-400 transition-transform duration-200"
                            :class="isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"
                        ></i>
                    </span>
                </template>
            </div>
        </div>
    </li>
</template>
